import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback } from "@/Components/ui";
;
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../../../Components/Common/DeleteModal";
import toast, { Toaster } from 'react-hot-toast';
import { read, utils, writeFileXLSX, writeFile } from "xlsx";
import ServerPaginatedTable from "../../../Components/Common/ServerPaginatedTable";
import { addReservationItem, API_PACKAGE, API_PACKAGE_OFFDAYS, API_RESERVATIONS, changeOffDay, changeReservationState, createOffDay, deleteReservationItem, getDataFromUrl, refundReservationItem, } from "../../../api";
import { SpotUnavailableReason, spotUnavailabilityService } from "../../../api/services/spot-unavailability.service";
import moment from "moment";
import ReservationAddModal from "../../../Components/ReservationAddModal";
import DeleteOrRefundModal from "../../../Components/Common/DeleteOrRefundModal";
import ReservationChangeModal from "../../../Components/ReservationChangeModal";
import { dialogService } from "@/utils/dialogService";
function printDiv(elid) {
    var divContents = document.getElementById(elid).innerHTML;
    var a = window.open("", "", "height=700, width=500");
    a.document.write("<html>");
    a.document.write('<body><table class="custom-header-css table">');
    a.document.write(divContents);
    // console.log(divContents)
    a.document.write("</table></body></html>");
    a.document.close();
    a.print();
}
const SubCardTable = ({ targetDate, targetDateText, packageId, packageTitle, packageCount, packageReserved, today, packagePrice, allowFreeBooking, offdayRefreshKey = 0 }) => {
    // const navigate = useNavigate();
    const selectReservationState = useMemo(() => {
        return [
            { label: "예약", value: "예약" }, // 구입후 기본 상태
            { label: "입장", value: "입장" }, // 예약날짜에 와서 입장한 상태
            { label: "외출", value: "외출" }, // 입장후 잠시 외출한 상태
            { label: "퇴장", value: "퇴장" },
            { label: "완료", value: "완료" }, // 사용 완료한 상태. 입장상태에서 날짜가 지나면 완료로 바꿈
            { label: "노쇼", value: "노쇼" }, // 예약날짜에 나타나지 않아서 환불도 불가한 상태
        ];
    }, []);
    const [offdayData, setOffDayData] = useState({});
    const [isDayAvailable, setisDayAvailable] = useState(false);
    const [showChangeModal, setShowChangeModal] = useState(false);
    const [targetCell, setTargetCell] = useState(null);
    const columns = React.useMemo(() => [
        // {
        //     Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()} />,
        //     Cell: (cellProps) => {
        //         return <input type="checkbox" className="customerCheckBox form-check-input" value={cellProps.row.original.id} />;
        //     },
        //     id: '#',
        // },
        // {
        //   Header: "ID",
        //   accessor: "id",
        //   id: "id",
        // },
        {
            Header: "예약신청일",
            accessor: "예약신청일",
            id: "",
            Cell: (cellProps) => {
                return <div>
            <div>{moment(cellProps.row.original["예약신청일"]).format("YYYY-MM-DD HH:mm")}</div>
            <div className="text-muted">{cellProps.row.original["id"]}</div>
          </div>;
            },
        }, //end_date, id, options, order, order_id, review, spot, spot_id, start_date
        {
            Header: "예약상품",
            accessor: "예약상품",
            id: "order",
        },
        {
            Header: "자리",
            accessor: "자리",
            id: "spot",
            Cell: (cellProps) => {
                const assignedSeat = cellProps.row.original["assigned_seat"];
                const spotLabel = String(cellProps.row.original["자리"] || "").startsWith("virtual") ? "자유석" : cellProps.row.original["자리"];
                return (<div>
              <div>{spotLabel}</div>
              {assignedSeat?.name ? <div className="text-success small">배정: {assignedSeat.name}</div> : null}
            </div>);
            },
        },
        {
            Header: "예약자",
            accessor: "예약자",
            id: "order__user__username",
            Cell: (cellProps) => {
                return (<div>
              <div>{cellProps.row.original["예약자"]}</div>
              <div className="text-muted">{cellProps.row.original["번호"]}</div>
            </div>);
            },
        },
        // {
        //   Header: "번호",
        //   accessor: "번호",
        //   id: "order__user__phone_num",
        // },
        {
            Header: "예약시작일",
            accessor: "예약시작일",
            id: "start_date",
            Cell: (cellProps) => {
                return <div>
            <div>{moment(cellProps.row.original["예약시작일"]).format("YYYY-MM-DD")}</div>
            <div>{moment(cellProps.row.original["예약종료일"]).format("YYYY-MM-DD")}</div>
          </div>;
            },
        },
        // {
        //   Header: "예약종료일",
        //   accessor: "예약종료일",
        //   id: "end_date",
        // },
        // {
        //   Header: "이용기간",
        //   accessor: "이용기간",
        //   id: "",
        // },
        {
            Header: "예약상태",
            accessor: "예약상태",
            id: "",
            Cell: (cellProps) => {
                const selref = useRef(null);
                useEffect(() => {
                    if (selref) {
                        // selref.current.value = cellProps.row.original['예약상태']
                        selref.current.setValue(selectReservationState.find((val) => {
                            return cellProps.row.original["예약상태"].valueOf() === val.value.valueOf();
                        }), "deselect-option");
                    }
                }, [cellProps, selref]);
                // console.log(cellProps.row, cellProps.row.original['예약상태'])
                return (<>
              {/* <span>{cellProps.row.original['예약상태']}</span> */}
              <Select ref={selref} className="mb-0" defaultValue={selectReservationState.find((val) => {
                        return cellProps.row.original["예약상태"].valueOf() === val.value.valueOf();
                    })} onChange={(val) => {
                        if (cellProps.row.original["예약상태"].valueOf() === val.value.valueOf())
                            return;
                        changeReservationState(cellProps.row.original.id, val.value).then((data) => {
                            console.log("changeReservationState", data);
                            toast.success(`예약상태를 변경하였습니다!\n : ${cellProps.row.original["예약자"]} ${cellProps.row.original["예약상태"]}=>${val.value}`, {
                                position: "top-right",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "light",
                            });
                        });
                    }} options={selectReservationState} id={"choices-single-" + cellProps.row.original.id}></Select>
            </>);
            },
        },
        {
            Header: "결제방법",
            accessor: "method",
            id: "method",
        },
        // {
        //   Header: "승인번호",
        //   accessor: "승인번호",
        //   id: "",
        // },
        {
            Header: "Actions",
            accessor: "Actions",
            id: "",
            Cell: (cellProps) => {
                return (<div className="d-flex gap-2">

              <div className="move_spot">
                <Button color="primary" onClick={() => {
                        setTargetCell(cellProps.row.original);
                        setShowChangeModal(true);
                    }}>
                  자리변경
                </Button>
              </div>

              <div className="remove">
                <div className="text-danger" style={{ cursor: "pointer" }} onClick={() => {
                        onClickDelete(cellProps.row.original.id);
                    }}>
                  <i className="ri-delete-bin-5-fill fs-16"></i>
                </div>
              </div>
            </div>);
            },
        },
    ], [selectReservationState]);
    const [checkedRecords, setCheckedRecords] = React.useState([]);
    const [deleteModal, setDeleteModal] = React.useState(false);
    const [deleteModalMulti, setDeleteModalMulti] = React.useState(false);
    const [addModal, setAddModal] = useState(false);
    const [blockModal, setBlockModal] = useState(false);
    const [blockLoading, setBlockLoading] = useState(false);
    const [blockSubmitLoading, setBlockSubmitLoading] = useState(false);
    const [blockReleaseLoadingId, setBlockReleaseLoadingId] = useState<number | null>(null);
    const [blockSpotOptions, setBlockSpotOptions] = useState<any[]>([]);
    const [blockList, setBlockList] = useState<any[]>([]);
    const [blockForm, setBlockForm] = useState({
        spots: [] as string[],
        start_date: targetDateText,
        end_date: targetDateText,
        reason: "maintenance" as SpotUnavailableReason,
        memo: "",
    });
    const blockSpotSelectOptions = useMemo(() => blockSpotOptions.map((spot) => ({
        value: String(spot.id),
        label: spot.name,
    })), [blockSpotOptions]);
    const blockSelectedSpotOptions = useMemo(() => blockSpotSelectOptions.filter((option) => blockForm.spots.includes(option.value)), [blockSpotSelectOptions, blockForm.spots]);
    const [data, setData] = React.useState([]);
    const [previous, setPrevious] = React.useState("");
    const [next, setNext] = React.useState("");
    const [count, setCount] = React.useState("");
    const abortReservController = useRef(null);
    const abortOffdayController = useRef(null);
    const onRequestData = (_url) => {
        console.log("onRequestData", _url);
        getDataFromUrl(_url)
            .then((data) => {
            setData(data.results);
            setPrevious(data.previous);
            setNext(data.next);
            setCount(data.count);
        })
            .catch((e) => {
            console.log(e);
        });
    };
    const fetchData = useCallback(() => {
        if (abortReservController.current) {
            abortReservController.current.abort("AbortError");
        }
        abortReservController.current = new AbortController();
        getDataFromUrl(`${API_RESERVATIONS}/?sort=spot&order=desc&package=${packageId}&date=${targetDateText}`, abortReservController.current.signal)
            .then((data) => {
            // console.log(data);
            setData(data.results);
            setPrevious(data.previous);
            setNext(data.next);
            setCount(data.count);
        })
            .catch((e) => {
            if (e.name === "AbortError") {
                console.log(e);
            }
            console.log(e);
        });
    }, [packageId, targetDateText]);
    React.useEffect(() => {
        fetchData();
        if (abortOffdayController.current) {
            abortOffdayController.current.abort("AbortError");
        }
        abortOffdayController.current = new AbortController();
        getDataFromUrl(`${API_PACKAGE_OFFDAYS}/?package=${packageId}&date=${targetDateText}`, abortOffdayController.current.signal)
            .then((data) => {
            if (data.length) {
                console.log("PACKAGE_OFFDAYS", packageId, data);
                for (let i = 0; i < data.length; i++) {
                    const element = data[i];
                    setOffDayData(element);
                }
            }
            else {
                setOffDayData({});
            }
        })
            .catch((e) => {
            if (e.name === "AbortError") {
                console.log(e);
            }
        });
    }, [packageId, targetDateText, fetchData, offdayRefreshKey]);
    const fetchBlockData = useCallback(async () => {
        setBlockLoading(true);
        try {
            const [packageData, blockResponse] = await Promise.all([
                getDataFromUrl(`${API_PACKAGE}/items/?date=${targetDateText}&include_hidden=true`),
                spotUnavailabilityService.list({
                    package: packageId,
                    start_date: targetDateText,
                    end_date: targetDateText,
                    is_active: true,
                    page_size: 100,
                }),
            ]);
            const targetPackage = Array.isArray(packageData) ? packageData.find((item) => item.id === packageId) : null;
            const spots = Array.isArray(targetPackage?.spots) ? targetPackage.spots : [];
            setBlockSpotOptions(spots);
            setBlockList(blockResponse.data.results || []);
            setBlockForm((current) => ({
                ...current,
                spots: current.spots.filter((spotId) => spots.some((spot) => String(spot.id) === spotId)),
            }));
        }
        catch (error) {
            console.warn(error);
            toast.error(dialogService.normalizeMessage(error) || "예약불가 정보를 불러오지 못했습니다.");
        }
        finally {
            setBlockLoading(false);
        }
    }, [packageId, targetDateText]);
    const openBlockModal = () => {
        setBlockForm({
            spots: [],
            start_date: targetDateText,
            end_date: targetDateText,
            reason: "maintenance" as SpotUnavailableReason,
            memo: "",
        });
        setBlockModal(true);
        void fetchBlockData();
    };
    const handleCreateSpotBlock = async () => {
        if (!blockForm.spots.length) {
            toast.warning("차단할 자리를 선택해 주세요.");
            return;
        }
        if (!blockForm.start_date || !blockForm.end_date) {
            toast.warning("기간을 입력해 주세요.");
            return;
        }
        if (moment(blockForm.end_date).isBefore(moment(blockForm.start_date), "day")) {
            toast.warning("종료일은 시작일 이후여야 합니다.");
            return;
        }

        setBlockSubmitLoading(true);
        try {
            const results = await Promise.allSettled(blockForm.spots.map((spotId) => spotUnavailabilityService.create({
                spot: Number(spotId),
                start_date: blockForm.start_date,
                end_date: blockForm.end_date,
                reason: blockForm.reason,
                memo: blockForm.memo,
            })));
            let successCount = 0;
            let overlapCount = 0;
            let firstError = null;

            results.forEach((result) => {
                if (result.status === "fulfilled") {
                    successCount += 1;
                    overlapCount += result.value.data.overlapping_reservation_count || 0;
                    return;
                }
                firstError = firstError || result.reason;
            });

            if (successCount) {
                const successMessage = successCount > 1 ? `${successCount}개 자리를 예약불가로 설정했습니다.` : "예약불가로 설정했습니다.";
                toast.success(overlapCount ? `${successMessage} 기존 예약 ${overlapCount}건은 유지됩니다.` : successMessage);
                setBlockForm((current) => ({ ...current, spots: [], memo: "" }));
                await fetchBlockData();
            }

            if (firstError) {
                toast.error(dialogService.normalizeMessage(firstError) || `${blockForm.spots.length - successCount}개 자리 예약불가 설정에 실패했습니다.`);
            }
        }
        catch (error) {
            console.warn(error);
            toast.error(dialogService.normalizeMessage(error) || "자리 예약불가 설정에 실패했습니다.");
        }
        finally {
            setBlockSubmitLoading(false);
        }
    };
    const handleReleaseSpotBlock = async (blockId) => {
        setBlockReleaseLoadingId(blockId);
        try {
            await spotUnavailabilityService.update(blockId, { is_active: false });
            toast.success("예약불가 설정을 해제했습니다.");
            await fetchBlockData();
        }
        catch (error) {
            console.warn(error);
            toast.error(dialogService.normalizeMessage(error) || "예약불가 해제에 실패했습니다.");
        }
        finally {
            setBlockReleaseLoadingId(null);
        }
    };
        const handleBlockPackageDate = async () => {
          const confirmed = await dialogService.confirm({
            title: "해당날짜 예약막기",
            description: `${packageTitle} (${targetDateText}) 예약을 막으시겠습니까?`,
            confirmLabel: "예약 막기",
            cancelLabel: "취소",
            tone: "warning",
          });
          if (!confirmed) {
            return;
          }

          if (offdayData.id) {
            changeOffDay(offdayData.id, packageId, targetDateText, true).then((data) => {
              setOffDayData(data);
            });
          }
          else {
            createOffDay(packageId, targetDateText, true).then((data) => {
              setOffDayData(data);
            });
          }
        };
    useEffect(() => {
        // ** 예약 가능 상태 판단
        // 오늘 이전 날짜인지
        // 부킹이 꽉 찼는지
        // period 에 휴무가 있고, 오늘이 휴무에 걸리는지
        // OffDays 에 오늘 날짜가 걸리는지
        //  // OffDays에 오늘 날짜가 걸리는 경우 휴무 취소 할 수 있다.
        if (moment(today).startOf("day") - moment(targetDate).startOf("day") > 0 || packageCount - packageReserved < 1 || offdayData.isDayOffInPeriod) {
            setisDayAvailable(false);
        }
        else if (offdayData.dayoff) {
            setisDayAvailable(false);
        }
        else if (!packagePrice && !allowFreeBooking) {
            setisDayAvailable(false);
        }
        else {
            setisDayAvailable(true);
        }
    }, [offdayData, today, targetDate, packageCount, packageReserved, packagePrice, allowFreeBooking]);
    const checkedAll = () => {
        const checkall = document.getElementById("checkBoxAll");
        const ele = document.querySelectorAll(".customerCheckBox");
        if (checkall.checked) {
            ele.forEach((ele) => {
                ele.checked = true;
            });
        }
        else {
            ele.forEach((ele) => {
                ele.checked = false;
            });
        }
    };
    const onClickDelete = (order) => {
        setCheckedRecords([order]);
        setDeleteModal(true);
    };
    const deleteRecords = async () => {
        const ele = document.querySelectorAll(".customerCheckBox:checked");
        const checkall = document.getElementById("checkBoxAll");
        if (ele.length === 0) {
            await dialogService.handleAlert("삭제할 항목이 없습니다.");
            return;
        }
        ele.forEach((element) => {
            console.log("reservation id:", element.value);
            deleteReservationItem(element.value)
                .then((data) => {
                console.log("deleteReservationItem:", data);
                fetchData();
            })
                .catch(async (e) => {
                await dialogService.handleAlert("항목 삭제 실패했습니다!", { force: "error" });
                console.warn(e);
            });
            element.checked = false;
        });
    };
    const handleDeleteOrder = (cancelAmtount = 0) => {
        if (checkedRecords.length) {
            checkedRecords.forEach((value) => {
                console.log("reservation id:", value);
                deleteReservationItem(value, cancelAmtount)
                    .then(async (data) => {
                    console.log("deleteReservationItem:", data);
                    if (data.error) {
                        await dialogService.handleAlert("요청실패: " + data.error);
                        return;
                    }
                    fetchData();
                })
                    .catch(async (e) => {
                    await dialogService.handleAlert("항목 삭제 실패했습니다!", { force: "error" });
                    console.warn(e);
                });
            });
            setDeleteModal(false);
        }
    };
    const addReservData = async (dataList) => {
        if (dataList === null || dataList.length === 0) {
            await dialogService.handleAlert("예약정보가 없습니다. 다시 확인해주세요.");
            return;
        }
        Promise.all(dataList.map(data => addReservationItem(data)))
            .then(async (results) => {
            if (results.every(data => data["result"] === "ok")) {
                await dialogService.handleAlert("예약이 추가되었습니다.");
                fetchData();
            }
            else {
                await dialogService.handleAlert("something went wrong!");
                console.log("add reservation failed.", results);
            }
        })
            .catch(e => console.log(e));
    };
    const handleRefundOrder = (cancelAmtount = 0) => {
        if (checkedRecords.length) {
            checkedRecords.forEach((value) => {
                console.log("reservation id:", value);
                refundReservationItem(value, cancelAmtount)
                    .then(async (data) => {
                    console.log("refundReservationItem:", data);
                    if (data.error) {
                        await dialogService.handleAlert("요청실패: " + data.error);
                        return;
                    }
                    toast.success(data.message, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                    fetchData();
                })
                    .catch(async (e) => {
                    await dialogService.handleAlert("항목 삭제 실패했습니다!", { force: "error" });
                    console.warn(e);
                });
            });
            setDeleteModal(false);
        }
    };
    return (<div>
    <DeleteOrRefundModal show={deleteModal} onDeleteClick={handleDeleteOrder} onCloseClick={() => setDeleteModal(false)} onRefundClick={handleRefundOrder} itemPrice={checkedRecords[0] && data.find((item) => item.id === checkedRecords[0]) ? data.find((item) => item.id === checkedRecords[0])["결제금액"] : 0} packageRefundAmount={checkedRecords[0] && data.find((item) => item.id === checkedRecords[0]) ? data.find((item) => item.id === checkedRecords[0])["패키지환불금액"] : 0} totalRefundAmount={checkedRecords[0] && data.find((item) => item.id === checkedRecords[0]) ? data.find((item) => item.id === checkedRecords[0])["환불예상금액"] : 0}/>
      <DeleteModal show={deleteModalMulti} onDeleteClick={() => {
            deleteRecords();
            setDeleteModalMulti(false);
        }} onCloseClick={() => setDeleteModalMulti(false)}/>

      <ReservationAddModal show={addModal} reservDate={targetDateText} reservProduct={packageTitle} onAddClick={(dataBody) => {
            console.log("add modal excute:", dataBody);
            addReservData(dataBody);
        }} onCloseClick={() => setAddModal(false)}/>

      <Modal isOpen={blockModal} onClose={() => setBlockModal(false)} centered={true} className="modal-dialog-centered modal-lg">
        <ModalHeader toggle={() => setBlockModal(false)}>자리 예약불가 설정</ModalHeader>
        <ModalBody>
          <div className="mb-3">
            <div className="text-muted">{packageTitle}</div>
            <div className="fw-semibold">{targetDateText}</div>
          </div>
          <Row className="g-3">
            <Col md={12}>
              <div className="d-flex align-items-center justify-content-between gap-2">
                <Label className="form-label mb-1">자리</Label>
                <div className="d-flex align-items-center gap-2">
                  <span className="text-muted small">{blockForm.spots.length}개 선택</span>
                  <Button
                    color="soft-secondary"
                    size="sm"
                    disabled={blockLoading || blockSubmitLoading || !blockSpotSelectOptions.length}
                    onClick={() => setBlockForm((current) => ({ ...current, spots: blockSpotSelectOptions.map((option) => option.value) }))}
                  >
                    전체 선택
                  </Button>
                  <Button
                    color="soft-secondary"
                    size="sm"
                    disabled={blockLoading || blockSubmitLoading || !blockForm.spots.length}
                    onClick={() => setBlockForm((current) => ({ ...current, spots: [] }))}
                  >
                    선택 해제
                  </Button>
                </div>
              </div>
              <Select
                isMulti
                closeMenuOnSelect={false}
                className="mb-0"
                value={blockSelectedSpotOptions}
                options={blockSpotSelectOptions}
                isDisabled={blockLoading || blockSubmitLoading}
                isLoading={blockLoading}
                placeholder="자리를 선택하세요"
                noOptionsMessage={() => "선택 가능한 자리가 없습니다."}
                onChange={(selectedOptions) => setBlockForm((current) => ({
                    ...current,
                    spots: (selectedOptions || []).map((option) => option.value),
                }))}
              />
            </Col>
            <Col md={4}>
              <Label className="form-label">시작일</Label>
              <Input
                type="date"
                value={blockForm.start_date}
                disabled={blockLoading || blockSubmitLoading}
                onChange={(event) => setBlockForm((current) => ({ ...current, start_date: event.target.value }))}
              />
            </Col>
            <Col md={4}>
              <Label className="form-label">종료일</Label>
              <Input
                type="date"
                value={blockForm.end_date}
                disabled={blockLoading || blockSubmitLoading}
                onChange={(event) => setBlockForm((current) => ({ ...current, end_date: event.target.value }))}
              />
            </Col>
            <Col md={4}>
              <Label className="form-label">사유</Label>
              <Input
                type="select"
                value={blockForm.reason}
                disabled={blockLoading || blockSubmitLoading}
                onChange={(event) => setBlockForm((current) => ({ ...current, reason: event.target.value as SpotUnavailableReason }))}
              >
                <option value="maintenance">점검</option>
                <option value="operation">운영</option>
                <option value="private_event">대관</option>
                <option value="repair">수리</option>
                <option value="other">기타</option>
              </Input>
            </Col>
            <Col md={8}>
              <Label className="form-label">메모</Label>
              <Input
                value={blockForm.memo}
                disabled={blockLoading || blockSubmitLoading}
                onChange={(event) => setBlockForm((current) => ({ ...current, memo: event.target.value }))}
                placeholder="운영 메모"
              />
            </Col>
          </Row>
          <div className="mt-3 d-flex justify-content-end">
            <Button color="primary" disabled={blockLoading || blockSubmitLoading || !blockSpotOptions.length} onClick={handleCreateSpotBlock}>
              {blockSubmitLoading ? "저장 중" : "예약불가 저장"}
            </Button>
          </div>

          <div className="mt-4">
            <h6 className="mb-2">현재 날짜에 걸린 예약불가 자리</h6>
            {blockLoading ? (
              <div className="text-muted">불러오는 중입니다.</div>
            ) : blockList.length ? (
              <div className="table-responsive">
                <table className="table table-sm align-middle">
                  <thead>
                    <tr>
                      <th>자리</th>
                      <th>기간</th>
                      <th>사유</th>
                      <th>기존 예약</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {blockList.map((block) => (
                      <tr key={block.id}>
                        <td>{block.spot_name}</td>
                        <td>{block.start_date} ~ {block.end_date}</td>
                        <td>{block.reason}</td>
                        <td>{block.overlapping_reservation_count}건</td>
                        <td className="text-end">
                          <Button
                            color="soft-secondary"
                            size="sm"
                            disabled={blockReleaseLoadingId === block.id}
                            onClick={() => handleReleaseSpotBlock(block.id)}
                          >
                            {blockReleaseLoadingId === block.id ? "해제 중" : "해제"}
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="text-muted">예약불가로 설정된 자리가 없습니다.</div>
            )}
          </div>
        </ModalBody>
      </Modal>

            <Card>
                <CardHeader className="card-header border-0">
                    <div className="d-flex align-items-center">
                        <h5 className="card-title mb-0 flex-grow-1">{packageId}: {packageTitle} 예약 목록 (가격: {new Intl.NumberFormat("ko-KR").format(packagePrice)}원, 예약건수: {new Intl.NumberFormat("ko-KR").format(packageReserved)}건)</h5>
            <div className="flex-shrink-0">
              {isDayAvailable ? <span>예약가능</span> : <span>예약불가</span>}
              <span style={{ padding: "18px" }}></span>

              <Button color="soft-warning" onClick={openBlockModal} disabled={blockLoading}>
                자리 예약 막기
              </Button>
              <span style={{ padding: "8px" }}></span>

              {moment(today).startOf("day") - moment(targetDate).startOf("day") > 0 || packageCount - packageReserved < 1 || offdayData.isDayOffInPeriod ||
            (!packagePrice && !allowFreeBooking) ? null : (<>
                  {offdayData.dayoff ? (<Button onClick={() => {
                    changeOffDay(offdayData.id, packageId, targetDateText, false).then((data) => {
                        setOffDayData(data);
                    });
                }} color="secondary">
                      예약불가 풀기
                    </Button>) : (<Button onClick={handleBlockPackageDate} color="primary">
                      해당날짜 예약막기
                    </Button>)}
                </>)}

              <span style={{ padding: "18px" }}></span>
              <Button onClick={() => {
            const worksheet = utils.table_to_sheet(document.getElementById("reservations-table"));
            const workbook = utils.book_new();
            utils.book_append_sheet(workbook, worksheet);
            writeFileXLSX(workbook, "output.xlsx");
            // writeFile(workbook, "output.csv")
        }} color="soft">
                <i className="ri-save-2-line"></i>
              </Button>
              <span style={{ padding: "4px" }}></span>
              <Button onClick={() => {
            printDiv("reservations-table");
        }} color="soft">
                <i className="ri-printer-line"></i>
              </Button>
              <span style={{ padding: "4px" }}></span>
              {/* <Button
                          onClick={() => setDeleteModalMulti(true)}
                       color="soft-danger"><i
                          className="ri-delete-bin-2-line"></i></Button> */}
            </div>
          </div>
        </CardHeader>

        <CardBody className="pt-0 px-2">
          <div className="card-body pt-0 px-2">
            <div>
              <React.Fragment>
                <ServerPaginatedTable key={`reservations-table-package-${packageId}-${packageTitle}`} id={`reservations-table-package-${packageId}-${packageTitle}`} serachable={false} url={API_RESERVATIONS} columns={columns} tableQuery={{
            sort: "spot",
            order: "desc",
            package: packageId,
            date: targetDateText,
        }} data={data} previous={previous} next={next} count={count} onRequestData={onRequestData} categories={[]}/>
              </React.Fragment>
            </div>

            {isDayAvailable ? (<div>
                <Button color="success" className="add-btn me-1" onClick={() => {
                setAddModal(true);
            }} id="create-btn">
                  새 예약 추가
                </Button>
              </div>) : null}
          </div>

          <Toaster position="top-center"/>
        </CardBody>
      </Card>


      <ReservationChangeModal visible={showChangeModal} toggle={() => setShowChangeModal(!showChangeModal)} targetData={targetCell} refreshPage={fetchData}/>

    </div>);
};
export default SubCardTable;
